.wrapper { // This keeps the background covering the page even as the user scrolls
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  overflow: auto;
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
  background-image: url('../assets/worldservice-tile.svg');
  background-color: initial !important;

  >div:first-child {
    flex: 1;
    position: relative;
  }

  @media (max-width: 800px) {
    padding-top: 0.5rem;
  }
}

.onlineStatus {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  justify-content: center;
}

.loadingWrapper {
  display: flex;
  justify-content: center;
  margin-top: 3rem;
}

.progressIndicatorContainer {
  overflow: hidden;
  max-height: 0;
  opacity: 0;
  transition: max-height 0.4s ease, opacity 0.3s ease;
}

.openProgressIndicator {
  max-height: 320px;
  opacity: 1;
  margin-bottom: 1rem;
}

.geoInfoWrapper {
  margin-top: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}

.copyrightTextWrapper {
  margin-top: auto;

  @media (max-width: 800px) {
    margin-top: 5rem;
  }
}

.slackChannelLink {
  text-underline-offset: 0.25rem;
}
